
import {
  Route,
  Routes
} from 'react-router-dom';
import {
  EmployerSession
} from '../components/Employers/EmployerPendings/EmployerSession';
import Navigate from '../components/Layout/Wrappers/Navigate';
import ForgotPassword from '../components/Login/ForgotPassword';
import Login from '../components/Login/Login';
import ResetPassword from '../components/Login/ResetPassword';
import {
  URL__JWT__EXPIRED,
  URL__JWT__INVALID,
  URL__JWT__SESSION
} from '../lib/services/Accounts/Session.lib';

const Unlogged = () => (
  <Routes>
    <Route path="/" element={<Navigate replace to="/login" />} />
    <Route path={String(URL__JWT__SESSION).replace('/#', '')} element={<EmployerSession />} />
    <Route path={String(URL__JWT__EXPIRED).replace('/#', '')} element={<EmployerSession />} />
    <Route path={String(URL__JWT__INVALID).replace('/#', '')} element={<Login />} />
    <Route path="/login" element={<Login />} />
    <Route path="/forgot/password" element={<ForgotPassword />} />
    <Route path="/reset/password/:token" element={<ResetPassword />} />
    <Route path="*" element={<Navigate replace to="/login" />} />
  </Routes>
);
export default Unlogged;
